export default "__VITE_ASSET__c90fd194__"